const firebaseConfig = {
    //Your firebase configuratrion here.
    apiKey: "AIzaSyCM-8WnURZUMXEp5RjwitMWOvZ9LwgKQRQ",
    authDomain: "feedmeback-baece.firebaseapp.com",
    projectId: "feedmeback-baece",
    storageBucket: "feedmeback-baece.appspot.com",
    messagingSenderId: "1071188006424",
    appId: "1:1071188006424:web:8ea1ef58163c081e80956d",
    measurementId: "G-TKQZRCT7Q4"
};

const colors = {
    primary: '#FFCB2B',
    secondary: '#8884d8'
}

export {
    firebaseConfig,
    colors
};